import React, { FunctionComponent } from "react";
import { Box, ResponsiveLayout } from "@bca/ui-library";
import LatestVersionSVG from "../Icons/LatestVersionSVG";
import ExclamationCircle from "../Icons/ExclamationCircle";
import VersionNavigationButton from "./VersionNavigationButton";
import { Devices, useViewport } from "../../hooks/useViewport";
import VersionNavigationText from "./VersionNavigationText";

interface VersionNavigationBannerProps {
  isLatestVersion: boolean;
  soldDate: string;
}

const VersionNavigationBanner: FunctionComponent<
  VersionNavigationBannerProps
> = ({ isLatestVersion, soldDate }) => {
  const device = useViewport();

  const isMobileDevice = device === Devices.MOBILE;

  return (
    <Box
      backgroundColor="primary-white"
      height={isMobileDevice ? "83px" : "73px"}
      display="flex"
      css={`
        position: sticky;
        top: 0;
        z-index: 4;
        box-shadow: 0px 3px 25px rgba(218, 218, 218, 0.370302);
      `}
    >
      <ResponsiveLayout
        display="flex"
        justifyContent={isMobileDevice ? "flex-start" : "space-between"}
        alignItems="center"
      >
        <Box
          display="flex"
          alignItems="center"
          width={!isMobileDevice ? "67%" : "100%"}
        >
          {isLatestVersion ? <LatestVersionSVG /> : <ExclamationCircle />}
          <Box marginLeft={3}>
            <VersionNavigationText
              variant={isMobileDevice ? "body-small" : "h6"}
              isLatestVersion={isLatestVersion}
            />
            {isMobileDevice && (
              <>
                {" "}
                <VersionNavigationButton
                  isLatestVersion={isLatestVersion}
                  soldDate={soldDate}
                  isMobileDevice={isMobileDevice}
                />
              </>
            )}
          </Box>
        </Box>
        {!isMobileDevice && (
          <Box>
            <VersionNavigationButton
              isLatestVersion={isLatestVersion}
              soldDate={soldDate}
              isMobileDevice={isMobileDevice}
            />
          </Box>
        )}
      </ResponsiveLayout>
    </Box>
  );
};

export default VersionNavigationBanner;
